'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Patentanzahl = require('../entity').Patentanzahl;

module.exports = function (connection) {
  return {
    byAnzahlEquals: function byAnzahlEquals(anzahl, additionalParams) {
      return templates.searchTemplate(connection)(Patentanzahl, 'byAnzahlEquals', 'anzahl')(anzahl, additionalParams);
    },
    byJahrEquals: function byJahrEquals(jahr, additionalParams) {
      return templates.searchTemplate(connection)(Patentanzahl, 'byJahrEquals', 'jahr')(jahr, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Patentanzahl, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Patentanzahl, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Patentanzahl, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('patentanzahl')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/patentanzahl.js
// module id = QRxE
// module chunks = 0